import React__default from 'react';
import { Avatar } from '@sravni/react-design-system/lib/Avatar';
import { Rate } from '@sravni/react-design-system/lib/Rate';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text, Link } from '@sravni/react-design-system/lib/Typography';
import { useStyles } from '@sravni/react-utils';
import { p as pluralize } from './chunks/pluralize-bbc8345a.js';

var modules_a1a2e57d = {"block":"_1ldlm1n","item":"_1iu0xs1"};
import "./assets/OrganizationRating.css";

var OrganizationRating$1 = function (_a) {
    var genitive = _a.genitive, list = _a.list, listUrl = _a.listUrl, className = _a.className;
    var cx = useStyles(modules_a1a2e57d);
    return (React__default.createElement("div", { className: cx('block', className) },
        !!genitive && React__default.createElement(Heading, { level: 4 },
            "\u0420\u0435\u0439\u0442\u0438\u043D\u0433 ",
            genitive),
        React__default.createElement(Space, { direction: "vertical", size: 0, className: "h-mt-12 h-mb-12" }, list.map(function (_a, index) {
            var link = _a.link, name = _a.name, rating = _a.rating, total = _a.total, logo = _a.logo, position = _a.position, onClick = _a.onClick;
            return (React__default.createElement("a", { target: "_top", href: link, key: "rating-".concat(link, "-").concat(name), onClick: onClick, className: cx('item') },
                React__default.createElement(Space, { align: "center", justify: "start" },
                    React__default.createElement(Text, { size: 12, className: "h-mr-8" }, position || index + 1),
                    React__default.createElement(Avatar, { size: 36, src: logo, className: "h-mr-12" }),
                    React__default.createElement(Space, { direction: "vertical", size: 2 },
                        React__default.createElement(Heading, { level: 5 }, name),
                        React__default.createElement(Space, { align: "center", size: 4 },
                            React__default.createElement(Rate, { count: 1, value: 1, size: 16, disabled: true, className: modules_a1a2e57d.rateStar }),
                            React__default.createElement(Text, { size: 12 }, !!rating && rating.toFixed(2).replace('.', ',')),
                            React__default.createElement(Text, { size: 12, className: "h-color-D30" },
                                String(total).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 '),
                                ' ',
                                !!total && pluralize(total, 'отзыв', 'отзыва', 'отзывов')))))));
        })),
        listUrl && (React__default.createElement(Link, { target: "_top", href: listUrl, strong: true }, "\u0412\u0435\u0441\u044C \u0440\u0435\u0439\u0442\u0438\u043D\u0433"))));
};

export { OrganizationRating$1 as OrganizationRating };
